import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const TehlikeliMaddePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px] bg-gradient-to-r from-violet-900 via-violet-800 to-purple-900 overflow-hidden mt-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 border-2 border-white rounded-full animate-pulse"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center mr-4">
                <i className="ri-flask-line text-6xl text-violet-300"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold">Tehlikeli Madde Danışmanlığı</h1>
            </div>
            <p className="text-xl md:text-2xl text-violet-100 leading-relaxed">
              Tehlikeli maddelerin güvenli kullanımı, depolanması ve taşınması için profesyonel danışmanlık
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          {/* Services Section */}
          <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
              <div className="text-center mb-16">
                <span className="text-teal-600 font-medium text-lg">Hizmetlerimiz</span>
                <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-6">Tehlikeli Madde Danışmanlığı Kapsamı</h2>
                <p className="text-gray-600 text-lg max-w-3xl mx-auto">
                  Tehlikeli maddelerin güvenli kullanımı, depolanması ve taşınması konusunda kapsamlı danışmanlık hizmetleri sunuyoruz.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 auto-rows-fr">
                {/* Card 1 */}
                <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-2xl p-8 border border-sky-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-sky-500 to-sky-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-flask-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Kimyasal Güvenlik Danışmanlığı</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    Kimyasal maddelerin güvenli kullanımı, depolanması ve acil durum prosedürleri konusunda uzman danışmanlık sağlıyoruz.
                  </p>
                </div>

                {/* Card 2 */}
                <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 border border-amber-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-file-shield-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">GBF ve Etiketleme</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    Güvenlik Bilgi Formları hazırlama ve kimyasal madde etiketleme konusunda mevzuata uygun çözümler sunuyoruz.
                  </p>
                </div>

                {/* Card 3 */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-truck-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Tehlikeli Madde Taşımacılığı</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    ADR mevzuatına uygun tehlikeli madde taşımacılığı konusunda danışmanlık ve eğitim hizmetleri veriyoruz.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Tehlikeli Madde Kategorileri */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Tehlikeli Madde Kategorileri</h2>
              <p className="text-gray-700 text-lg max-w-3xl mx-auto">
                GHS ve CLP sistemine göre sınıflandırılmış tehlikeli madde türleri
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[
                { title: 'Yanıcı Maddeler', icon: 'ri-fire-line', color: 'from-red-500 to-orange-500' },
                { title: 'Patlayıcı Maddeler', icon: 'ri-flashlight-line', color: 'from-orange-500 to-yellow-500' },
                { title: 'Zehirli Maddeler', icon: 'ri-skull-2-line', color: 'from-red-600 to-red-500' },
                { title: 'Aşındırıcı Maddeler', icon: 'ri-drop-line', color: 'from-sky-500 to-cyan-500' },
                { title: 'Oksitleyici Maddeler', icon: 'ri-flask-line', color: 'from-cyan-500 to-blue-500' },
                { title: 'Radyoaktif Maddeler', icon: 'ri-radioactive-line', color: 'from-orange-600 to-red-600' },
                { title: 'Basınçlı Gazlar', icon: 'ri-gas-station-line', color: 'from-gray-600 to-gray-700' },
                { title: 'Çevreye Zararlı', icon: 'ri-leaf-line', color: 'from-amber-600 to-orange-600' }
              ].map((category, index) => (
                <div key={index} className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 group h-48">
                  <div className={`bg-gradient-to-br ${category.color} p-8 h-full flex flex-col items-center justify-center text-center`}>
                    <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                      <div className="w-12 h-12 flex items-center justify-center">
                        <i className={`${category.icon} text-4xl text-white`}></i>
                      </div>
                    </div>
                    <h3 className="text-lg font-bold text-white">{category.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mevzuat Section */}
          <div className="mb-20 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-12 border-2 border-gray-200">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Mevzuat ve Standartlar</h2>
              <p className="text-gray-700 text-lg max-w-2xl mx-auto">
                Tehlikeli madde yönetiminde uyulması gereken ulusal ve uluslararası düzenlemeler
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                { icon: 'ri-book-line', title: 'ADR Mevzuatı', desc: 'Tehlikeli Maddelerin Karayolu ile Uluslararası Taşımacılığı' },
                { icon: 'ri-shield-check-line', title: 'REACH Yönetmeliği', desc: 'Kimyasalların Kaydı, Değerlendirilmesi ve Kısıtlanması' },
                { icon: 'ri-file-shield-line', title: 'CLP Yönetmeliği', desc: 'Maddelerin Sınıflandırılması, Etiketlenmesi ve Ambalajlanması' },
                { icon: 'ri-global-line', title: 'GHS Sistemi', desc: 'Kimyasalların Küresel Uyumlaştırılmış Sınıflandırma Sistemi' }
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className={`${item.icon} text-2xl text-white`}></i>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                      <p className="text-gray-700 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-violet-600 via-violet-700 to-purple-700 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Tehlikeli Madde Güvenliğinizi Sağlayın</h2>
            <p className="text-violet-100 text-lg md:text-xl mb-8 max-w-2xl mx-auto">
              İşyerinizdeki kimyasal maddelerin güvenli yönetimi için uzman kadromuzla iletişime geçin
            </p>
            <Link 
              to="/iletisim"
              className="inline-flex items-center bg-white text-violet-600 px-10 py-5 rounded-2xl font-bold text-lg hover:bg-violet-50 transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Danışmanlık Alın</span>
              <div className="w-6 h-6 flex items-center justify-center ml-3">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default TehlikeliMaddePage;
